/**
 * Client-side equivalent of Laravel Str::slug($name, '-') for product list URLs.
 */
export function slugFromName(name) {
    if (name === null || name === undefined) {
        return '';
    }

    const raw = String(name).trim();
    if (raw === '') {
        return '';
    }

    return raw
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
